// extracted by mini-css-extract-plugin
export default {"detailsLabel":"styles-module__fMTro"};